/**
 * League List Component
 * Handles smooth scrolling when clicking on league links
 */
function initLeagueList() {
  const leagueLinks = document.querySelectorAll('.league-list a[href^="#league-"]');

  if (leagueLinks.length === 0) {
    setTimeout(initLeagueList, 100);
    return;
  }

  leagueLinks.forEach((link) => {
    const newLink = link.cloneNode(true);
    link.parentNode.replaceChild(newLink, link);

    newLink.addEventListener('click', (e) => {
      e.preventDefault();

      const targetId = newLink.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 100;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLeagueList);
} else {
  initLeagueList();
}

setTimeout(initLeagueList, 200);
